import { Button } from "@progress/kendo-react-buttons";
import { TextArea } from "@progress/kendo-react-inputs";
import { useState } from "react";
import { Error } from "@progress/kendo-react-labels";
import { loginPrompt } from "../../utils/loginPrompt";
import { useNotificationAPI } from "../../components/NotificationProvider";
import { ObjectTypes } from "../../models/comments";

interface AddCommentProps {
    objectId: number,
    header: string,
    buttonText: string,
    execute: any,
    endpoint: string,
    afterAddFunction?: Function,
    setLoading?: Function,
    loginPrompt: boolean,
    objectTypeId?: ObjectTypes,
    children?: React.ReactNode
}

interface IAddCommentProps extends AddCommentProps {
}

export const AddComment = (props: IAddCommentProps) => {
    const [comment, setComment] = useState("");
    const notificationAPI = useNotificationAPI();

    const toAPIObject = () => {
        let object = { ObjectId: props.objectId, Text: comment } as any;
        if (props.objectTypeId) {
            object.ObjectTypeId = props.objectTypeId;
        }
        return object;
    }

    const addCommentButtonClick = () => {
        if (comment.length === 0) {
            notificationAPI.addNotification('You must enter in a comment', props.header, 'info');
            return;
        }

        props.setLoading?.(true);

        const thenFunction =
            (result: any) => {
                if (result !== undefined) {
                    props.afterAddFunction?.(result);
                }
                props.setLoading?.(false);
            };

        if (props.loginPrompt) {
            loginPrompt('POST', props.endpoint, toAPIObject(), notificationAPI.addNotifications, thenFunction, () => { props.setLoading?.(false) });
        } else {
            props.execute('POST', props.endpoint, toAPIObject()).then(thenFunction);
        }
    }

    return <div>
        <div>
            {props.header}
            <TextArea value={comment} onChange={(event) => setComment(event.value)}>
            </TextArea>
        </div>
        {comment.length === 0 &&
            <Error>A comment is required</Error>}
        <br></br>

        <Button onClick={addCommentButtonClick}>
            {props.buttonText}
        </Button>
    </div>;
}